import React from "react";

import { Container, Row, Col, Card } from "reactstrap";

import "react-circular-progressbar/dist/styles.css";

function AboutPoints() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <div
        className="section"
        style={{
          backgroundColor: "transparent",
        }}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <h1
                className="m-0 mb-3 text-g-p text-info"
                style={{
                  fontSize: size ? "3rem" : "2rem",
                }}
              >
                WHY BIRMINGHAM?
              </h1>
              <p className="text-400 text-dark mb-3">
                Birmingham is rapidly establishing itself as one of the UK&apos;s leading innovation
                and infrastructure hubs.
              </p>
              <p className="text-400 text-dark mb-4">
                As the nation&apos;s second-largest city, Birmingham is investing significantly in
                digital transformation, sustainable mobility, regeneration, clean energy, and smart
                city initiatives. Major developments, extensive transport upgrades, ambitious
                net-zero commitments, and one of Europe&apos;s largest city-centre regeneration
                programmes make Birmingham an ideal location to showcase the future of Digital Twin
                technologies.
              </p>
              <p className="text-400 text-dark mb-5">
                With strong collaboration between local government, academia, industry, and
                technology partners, Birmingham provides the perfect environment for advancing
                innovation in:
              </p>
            </Col>
          </Row>
          <Row className={` ${size ? "row-cols-4" : "row-cols-2"}`}>
            {whyBirmingham.map((c) => (
              <Col
                className="p-1"
                style={{
                  minHeight: size ? "220px" : "none",
                }}
                key={c.title}
              >
                <div className={`mb-4  px-1 text-dark text-left`}>
                  <img
                    src={require(`assets/icons/${c.image}`)}
                    width="100%"
                    alt="about"
                    style={{ maxWidth: "100px" }}
                    className="mb-3 mx-auto"
                  />
                  <h5 className="text-700 mt-0 ">{c.title}</h5>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
}

export function ConferenceFormat() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <div
      className="section"
      style={{
        backgroundColor: "transparent",
      }}
    >
      <Container>
        <Row>
          <Col md={12} className="pr-0">
            <h1
              className="m-0 my-4 text-g text-left"
              style={{
                fontSize: size ? "3rem" : "2rem",
              }}
            >
              Conference Format
            </h1>
          </Col>

          {conferenceFormat.map((c, i) => (
            <Col lg={6} xs={12} key={c.title}>
              <Card
                className=""
                style={{
                  background: i % 2 !== 0 ? "#00a8c4" : "#3e3f99",
                  height: size ? "90px" : "none",
                }}
              >
                <div className="d-flex p-2 align-items-center">
                  <div className="px-2 align-self-center">
                    <img
                      src={require(`assets/icons/${c.image}`)}
                      style={{ width: "70px" }}
                      width="100%"
                      alt="about"
                    />
                  </div>
                  <p className="text-400 py-2 text-white mb-0">{c.title}</p>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default AboutPoints;

const whyBirmingham = [
  {
    image: "Asset 5.png",
    title: "SMART CITIES & CONNECTED COMMUNITIES",
  },
  {
    image: "Asset 4.png",
    title: "URBAN PLANNING & CITY REGENERATION",
  },
  {
    image: "Asset 3.png",
    title: "BUILT ENVIRONMENT & DIGITAL CONSTRUCTION",
  },
  {
    image: "Asset 2.png",
    title: "TRANSPORTATION & INTELLIGENT MOBILITY",
  },
  {
    image: "Asset 1.png",
    title: "ENERGY NETWORKS & UTILITIES",
  },
  {
    image: "Asset 19.png",
    title: "INFRASTRUCTURE ASSET MANAGEMENT",
  },
  {
    image: "Asset 21.png",
    title: "AI, IoT, GIS, BIM & DATA INTEGRATION",
  },
];

const conferenceFormat = [
  {
    title: "TECHNICAL & INTERACTIVE PRE-CONFERENCE WORKSHOPS",
    image: "Asset 10.png",
  },
  {
    title: "VISIONARY KEYNOTES",
    image: "Asset 19.png",
  },
  {
    title: "CASE STUDIES AND PROOF OF CONCEPTS",
    image: "Asset 9.png",
  },
  {
    title: "THOUGHT-PROVOKING PANEL DISCUSSIONS",
    image: "Asset 13 2.png",
  },
  {
    title: "EXHIBITION & NETWORKING",
    image: "Asset 12.png",
  },
];
